document.addEventListener('DOMContentLoaded', () => {
  document.querySelector('.usp-container .icon-close').addEventListener('click', () => {
    document.querySelector('.usp-container').classList.add('hidden');
  });
  document.querySelectorAll('.quick-links .heading').forEach((heading) => {
    heading.addEventListener('mouseover', () => {
      heading.classList.add('active');
      for (const sibling of heading.parentNode.children) {
        if (sibling !== heading) sibling.classList.remove('active');
      }
      document.querySelectorAll('.header__inline-menu > .list-menu').forEach((menu) => {
        if (heading.dataset.id === menu.id) {
          menu.classList.remove('hidden');
        } else {
          menu.classList.add('hidden');
        }
      });
    });
    heading.addEventListener('click', () => {
      heading.classList.add('active');
      for (const sibling of heading.parentNode.children) {
        if (sibling !== heading) sibling.classList.remove('active');
      }
      document.querySelectorAll('.menu-drawer__navigation > .list-menu').forEach((menu) => {
        if (heading.dataset.id === menu.id) {
          menu.classList.remove('hidden');
        } else {
          menu.classList.add('hidden');
        }
      });
    });
  });
});
